import L from 'leaflet';

const cache = new Map<string, L.DivIcon>();

export function createEventIcon(
  emoji: string,
  attendeeCount: number,
  isHappening: boolean,
): L.DivIcon {
  const cacheKey = `${emoji}_${attendeeCount}_${isHappening}`;
  const cached = cache.get(cacheKey);
  if (cached) return cached;

  const size = isHappening ? 48 : 42;

  const glow = isHappening
    ? `<span style="position:absolute;inset:-8px;border-radius:50%;border:2.5px solid #22c55e;animation:stabeon-pulse 1.4s ease-out infinite;opacity:.9"></span>
       <span style="position:absolute;inset:-14px;border-radius:50%;border:1.5px solid #22c55e;animation:stabeon-pulse 1.4s ease-out 0.4s infinite;opacity:.5"></span>`
    : '';

  const badge = attendeeCount > 0
    ? `<span style="position:absolute;top:-4px;right:-4px;min-width:18px;height:18px;border-radius:9px;background:linear-gradient(135deg,#7c3aed,#a78bfa);color:white;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 4px;box-shadow:0 2px 6px rgba(124,58,237,0.5)">${attendeeCount > 99 ? '99+' : attendeeCount}</span>`
    : '';

  const liveBadge = isHappening
    ? `<span style="position:absolute;bottom:-9px;left:50%;transform:translateX(-50%);background:#22c55e;color:white;font-size:7px;font-weight:800;letter-spacing:0.5px;padding:1px 5px;border-radius:4px;white-space:nowrap;box-shadow:0 2px 6px rgba(34,197,94,0.5)">LIVE</span>`
    : '';

  const html = `
    <div style="position:relative;width:${size + 20}px;height:${size + 20}px;display:flex;align-items:center;justify-content:center;cursor:pointer">
      ${glow}
      <div style="
        width:${size}px;height:${size}px;
        border-radius:${isHappening ? '50%' : '16px'};
        background:${isHappening
          ? 'linear-gradient(135deg,rgba(34,197,94,0.25),rgba(124,58,237,0.2))'
          : 'linear-gradient(135deg,rgba(124,58,237,0.2),rgba(167,139,250,0.1))'};
        border:${isHappening ? '2.5px solid rgba(34,197,94,0.8)' : '2px solid rgba(124,58,237,0.6)'};
        backdrop-filter:blur(8px);
        display:flex;align-items:center;justify-content:center;
        font-size:${isHappening ? '22px' : '20px'};
        box-shadow:${isHappening ? '0 4px 20px rgba(34,197,94,0.35)' : '0 4px 16px rgba(124,58,237,0.3)'};
      ">${emoji}</div>
      ${badge}
      ${liveBadge}
    </div>`;

  const containerSize = size + 20;
  const icon = L.divIcon({
    html,
    className: '',
    iconSize: [containerSize, containerSize],
    iconAnchor: [containerSize / 2, containerSize / 2],
    popupAnchor: [0, -(containerSize / 2 + 6)],
  });

  cache.set(cacheKey, icon);
  return icon;
}
